(function() {
  angular.module('cfn').service('ShopService', ShopService);

  ShopService.$inject = ['$filter', 'i18nFilter', '$log'];
  function ShopService($filter, i18nFilter, $log) {
    'use strict';

    /**
     * Gibt zurück, ob das aktuelle Land ein ShopCountry ist, d.h. ob der Shop innerhalb der Plattform zu erreichen ist
     */
    this.isShopCountry = function() {
      return !!app.credentials.company.shopCountry;
    };

    /**
     * Gibt zurück, ob das Produkt mit dem gegebenen Product key aktuell lizensiert (gekauft oder im Test) ist
     */
    this.isProductLicensed = function(serviceKey) {
      var bookedModules = app.credentials.licensedProducts;

      return bookedModules && bookedModules.indexOf(serviceKey) > -1;
    };

    /**
     * Gibt zurück, ob mindestens ein Produkt mit dem gegebenen Abrechnungskriterium gekauft ist und sich eine
     * Änderung des Kriteriums daher auf den Preis auswirkt
     */
    this.doesPricingCriterionAffectPrice = function(pricingCriterionUnit) {
      var licensedCriterions = app.credentials.billedPricingCriteria;

      return (
        this.isShopCountry() &&
        licensedCriterions &&
        licensedCriterions.indexOf(pricingCriterionUnit) > -1
      );
    };

    /**
     * CFNPOC-10153
     */
    this.createBookedButton = function(model) {
      if (model.subscription.state.toLowerCase() === 'paid') {
        return i18nFilter('fe.admin.services.button.bookedOn').format(
          $filter('date')(model.subscription.contractOrderDate)
        );
      }
    };

    /**
     * CFNPOC-9822
     */
    this.createPromoCodeInputs = function(model) {
      if (
        model.subscription.product.productDevelopmentState === 'BETA' ||
        model.subscription.state.toLowerCase() === 'paid'
      )
        return false;
      else return true;
    };

    // @DEPRECATED CFNPOC-24277 ON 2017.08.29
    /**
     * CFNPOC-9702
     */
    this.compareAddresses = function(settings) {
      // fyi: fresh accounts will carry a zip-code NULL as billingAddress-property
      if (!settings.billingAddress.zip) return false;

      return;
      !angular.equals(
        {
          companyName: settings.businessAddress.companyName,
          formOfAddress: settings.anredeBuisness, // todo: TYPO IN JSON-RESPONSE!!! it's BUSINESS, for centuries now :D
          firstName: settings.firstNameBuisness, // todo: TYPO IN JSON-RESPONSE!!! it's BUSINESS, for centuries now :D
          lastName: settings.nameBuisness, // todo: TYPO IN JSON-RESPONSE!!! it's BUSINESS, for centuries now :D
          street: settings.businessAddress.street,
          houseNumber: settings.businessAddress.houseNumber,
          zip: settings.businessAddress.zip,
          town: settings.businessAddress.city,
          country: l.settings.businessAddress.country
        },
        {
          companyName: settings.billingAddress.companyName,
          formOfAddress: settings.anredeBilling,
          firstName: settings.firstNameBilling,
          lastName: settings.nameBilling,
          street: settings.billingAddress.street,
          houseNumber: settings.billingAddress.houseNumber,
          zip: settings.billingAddress.zip,
          town: settings.billingAddress.city,
          country: settings.billingAddress.country
        }
      );
    };
    // @DEPRECATED CFNPOC-24277 /END

    /**
     * CFNPOC-10977
     */
    this.determineLayoutCells = function(subscription) {
      if (
        !subscription ||
        !subscription.state ||
        !subscription.product ||
        !subscription.product.productKey ||
        !subscription.product.productDevelopmentState ||
        subscription.product.trialPeriodDurationInDays === 'undefined' ||
        !subscription.availableSubscriptionActions ||
        typeof subscription.hasBeenTested === 'undefined' ||
        subscription.hasBeenTested === null || // boolean prop
        typeof subscription.licensed === 'undefined' ||
        subscription.licensed === null
      ) {
        // boolean prop
        $log.error('the given subscription is an inconsistent one!');
        return 0;
      }

      /**
       *  one cell layout
       */

      // you are not allowed to test, but to book
      if (
        (!subscription.product.trialPeriodDurationInDays ||
          subscription.product.trialPeriodDurationInDays < 1) &&
        subscription.product.productDevelopmentState.toLowerCase() === 'final'
      )
        return 1;

      // you cancelled the booking, booking again allowed
      if (
        subscription.state.toLowerCase() === 'paid_cancelled' &&
        ~subscription.availableSubscriptionActions.indexOf('ORDER_PAID_LICENSE')
      )
        return 1;

      // trial period ended, booking a (normal) module allowed
      if (
        subscription.state.toLowerCase() === 'trial' &&
        !subscription.licensed &&
        ~subscription.availableSubscriptionActions.indexOf('ORDER_PAID_LICENSE')
      )
        return 1;

      // (normal) module booked
      if (
        subscription.state.toLowerCase() === 'paid' &&
        subscription.licensed &&
        ~subscription.availableSubscriptionActions.indexOf(
          'CANCEL_LICENSE'
        ) &&
        subscription.product.productDevelopmentState.toLowerCase() === 'final'
      )
        return 1;

      // (beta) module booked
      if (
        subscription.state.toLowerCase() === 'trial' &&
        subscription.licensed &&
          ~subscription.availableSubscriptionActions.indexOf(
              'CANCEL_LICENSE'
          ) &&
        subscription.product.productDevelopmentState.toLowerCase() === 'beta'
      )
        return 1;

      // booking a (beta) module allowed
      if (
        subscription.state.toLowerCase() === 'inactive' &&
        !subscription.licensed &&
        ~subscription.availableSubscriptionActions.indexOf(
          'ORDER_TRIAL_LICENSE'
        ) &&
        subscription.product.productDevelopmentState.toLowerCase() === 'beta' &&
        !subscription.product.trialPeriodDurationInDays
      )
        return 1;

      // you cancelled the (beta) module booking, booking again allowed
      if (
          subscription.state.toLowerCase() === 'trial_cancelled' &&
          ~subscription.availableSubscriptionActions.indexOf(
              'ORDER_TRIAL_LICENSE'
          ) &&
          subscription.product.productDevelopmentState.toLowerCase() === 'beta' &&
          !subscription.product.trialPeriodDurationInDays
      )
        return 1;

      /**
       *  two-cell layout
       */

      // trial period not yet running, module not yet booked
      if (
        subscription.state.toLowerCase() === 'inactive' &&
        !subscription.licensed &&
        ~subscription.availableSubscriptionActions.indexOf(
          'ORDER_PAID_LICENSE'
        ) &&
        ~subscription.availableSubscriptionActions.indexOf(
          'ORDER_TRIAL_LICENSE'
        ) &&
        subscription.product.productDevelopmentState.toLowerCase() ===
          'final' &&
        subscription.product.trialPeriodDurationInDays
      )
        return 2;

      // trial period running, module not yet booked
      if (
        subscription.state.toLowerCase() === 'trial' &&
        subscription.licensed &&
        ~subscription.availableSubscriptionActions.indexOf(
          'ORDER_PAID_LICENSE'
        ) &&
        subscription.product.productDevelopmentState.toLowerCase() ===
          'final' &&
        subscription.product.trialPeriodDurationInDays
      )
        return 2;
    };
  }
})();
